import React from "react";
var __jsx = React.createElement;
import cn from 'classnames';
import styled from 'styled-components';
import styles from './Skeleton.style';
function Skeleton(_ref) {
  var className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    type = _ref.type;
  return __jsx("span", {
    className: cn('nva-skeleton', "u-".concat(type), className)
  }, __jsx("span", {
    className: "nva-skeleton__line",
    style: {
      width: width,
      height: height ? height : "var(--g-font-size-".concat(type, ")"),
      marginBlock: "\n          calc(\n              var(--g-line-height-".concat(type, " * var(--g-font-size-").concat(type, "\n          )")
    }
  }));
}
export default styled(Skeleton).withConfig({
  componentId: "sc-1dcv8s5-0"
})(["", ";"], styles);